// Fotos e arquivos das fichas compartilhadas (0.25): ficam também na pasta do grupo no Supabase,
// para quem está no grupo abrir em qualquer aparelho. Só membros do grupo leem (regras no servidor).
import { useSyncExternalStore } from 'react';
import { supabase } from './supabase';
import { lerBase64 } from './anexos';
import { uid } from './date';
import type { Anexo } from '../store/types';

const BALDE = 'grupos';
const urls = new Map<string, { url: string; ate: number }>();
const pedindo = new Set<string>();
let versao = 0;
const ouvintes = new Set<() => void>();
const avisar = () => { versao++; ouvintes.forEach(f => f()); };

/** Re-renderiza quando chega o endereço de alguma imagem do grupo. */
export const useUrlsGrupo = () => useSyncExternalStore(cb => { ouvintes.add(cb); return () => ouvintes.delete(cb); }, () => versao);

/** Endereço temporário (1 hora) do arquivo do grupo. Sem ele ainda, pede e devolve undefined (a tela atualiza depois). */
export function urlGrupoJa(gp: string): string | undefined {
  const x = urls.get(gp);
  if (x && x.ate > Date.now()) return x.url;
  if (!pedindo.has(gp) && supabase) {
    pedindo.add(gp);
    supabase.storage.from(BALDE).createSignedUrl(gp, 3600)
      .then(({ data }) => { if (data?.signedUrl) { urls.set(gp, { url: data.signedUrl, ate: Date.now() + 3500 * 1000 }); avisar(); } })
      .catch(() => {}).finally(() => pedindo.delete(gp));
  }
  return undefined;
}
export async function urlGrupo(gp: string): Promise<string> {
  const ja = urls.get(gp);
  if (ja && ja.ate > Date.now()) return ja.url;
  if (!supabase) throw new Error('sem servidor');
  const { data, error } = await supabase.storage.from(BALDE).createSignedUrl(gp, 3600);
  if (error || !data?.signedUrl) throw error ?? new Error('arquivo não encontrado');
  urls.set(gp, { url: data.signedUrl, ate: Date.now() + 3500 * 1000 });
  return data.signedUrl;
}

function deB64(b64: string): Uint8Array {
  const tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  const limpo = b64.replace(/[^A-Za-z0-9+/]/g, '');
  const out = new Uint8Array(Math.floor((limpo.length * 3) / 4));
  let o = 0, buf = 0, bits = 0;
  for (const ch of limpo) {
    buf = (buf << 6) | tab.indexOf(ch); bits += 6;
    if (bits >= 8) { bits -= 8; out[o++] = (buf >> bits) & 0xff; }
  }
  return out.subarray(0, o);
}

/** Copia o arquivo (guardado neste aparelho) para a pasta do grupo. Devolve o caminho dele lá. */
export async function enviarArquivoAoGrupo(a: Anexo, grupo: string, reg: string): Promise<string> {
  if (!supabase) throw new Error('sem servidor');
  const bytes = deB64(await lerBase64(a));
  if (bytes.length > 25 * 1024 * 1024) throw new Error('arquivo grande demais');
  const nome = (a.nome || 'arquivo').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^\w.\-]+/g, '_').slice(-60);
  const caminho = `${grupo}/${reg}/${uid()}-${nome}`;
  const { error } = await supabase.storage.from(BALDE).upload(caminho, bytes, { contentType: a.mime || 'application/octet-stream', upsert: false });
  if (error) throw error;
  return caminho;
}
